<template>
    <!-- 预约成功 -->
    <div class="successnow">
        <van-row gutter="20">
            <van-col span="24">
                <el-result icon="success" title="预约成功" :subTitle="'订单号：' + orderID"></el-result>
            </van-col>
        </van-row>

        <van-row gutter="20">
            <van-col span="24">
                <div class="titlebox">
                    <span v-if="active == 1">您已预约成功，正在为您安排服务商</span>
                    <span v-else-if="active == 2">已成功安排服务商，请等待上门</span>
                    <span v-else-if="active == 3">服务已完成，感谢您的使用</span>
                </div>
            </van-col>
        </van-row>

        <van-row gutter="50">
            <!-- <van-col span="2">
                <van-image width="40" :src="logourl" />
            </van-col> -->
            <van-col span="24">
                <van-cell title="京东服务+" label="点击查看京东官方服务进度" is-link
                    url="https://ha-mrd.jd.com/repair/#/serviceOrderList">
                    <!-- <template v-slot:icon>
                        <img :src="logourl" style="width: 24px; height: 24px; margin-right: 8px;" />
                    </template> -->
                </van-cell>
            </van-col>
        </van-row>

        <van-row gutter="20">
            <van-col span="24">
                <van-steps :active="active" direction="vertical" center>
                    <van-step v-for="(item, index) in steps" :key="index">
                        <div class="stepbox">
                            <span>{{ item.text }}</span>
                            <span>{{ item.desc }}</span>
                        </div>
                    </van-step>
                </van-steps>
            </van-col>
        </van-row>

        <!-- <van-row gutter="20">
            <van-col span="24">

            </van-col>
        </van-row> -->

        <van-row gutter="20">
            <van-col span="24">
                <van-image :src="require('@/assets/人工客服.jpg')" />
            </van-col>
        </van-row>
    </div>
</template>


<script>
import { Result } from 'element-ui';
import { PostMsg } from '../constant.js'

export default {
    components: {
        ElResult: Result,
    },
    data() {
        return {
            logourl: require('@/assets/jingdong.jpg'),
            active: 2,
            steps: [
                {
                    text: '预约下单',
                    desc: '恭喜您下单成功，正在处理中，请稍等片刻',
                },
                {
                    text: '服务商接单',
                    desc: '您的订单已被接收，正在为您快速派单，请稍等',
                },
                {
                    text: '服务中',
                    desc: '等待服务商响应，我们会尽快为您提供服务',
                },
                {
                    text: '服务完成',
                    desc: '感谢您的使用，服务已完成',
                },
            ],
            orderID: '',
            state: ''
        }
    },
    mounted() {
        console.log(this.$route.query.policyNo); // 参数
        this.getTemporary(this.$route.query.policyNo) // 获取订单信息
    },
    methods: {
        // 获取订单信息
        getTemporary(policyNo) {
            PostMsg('/temporaryMsg/policyNoItem', {
                policyNo: policyNo
            }).then(res => {
                console.log('获取订单数据：', res);
                const { order_id, state } = res.data.data
                this.orderID = order_id

                // 根据服务状态判断流程
                switch (state) {
                    case 0:
                        this.active = 1
                        break;
                    case 1:
                        this.active = 2
                        break;
                    case 2:
                        this.active = 3
                        break;
                }
            })

        }
    }

}
</script>

<style lang="less" scoped>
.successnow {
    position: relative;
    width: 100%;

    .titlebox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 50px;
        // border: 1px solid red;
        font-weight: bold;
        font-size: 20px;
    }

    .stepbox {
        width: 100%;
        display: flex;
        flex-direction: column;

        span:nth-child(1) {
            font-weight: bold;
        }

        span:nth-child(2) {
            color: rgb(170, 170, 170);
            font-size: 12px;
        }

    }

}
</style>